<template>
  <div class="accept-container">
    <p>Congratulations! You've been awarded phantom shares. Please review and acknowledge these awards at the bottom of the page within {{ daysRemaining }} days. If you don't acknowledge them within this timeframe, they will be automatically revoked.</p>
    <div class="accept-pdf-wrapper">
      <PDFViewer
        class="pdf-viewer"
        :pdf-url="certificateUrl"
        :width="viewDimensions.width * 0.8"
      />
    </div>

    <p>
      By Accepting this Agreement, the Participant acknowledges having received the Agreement and applicable Award
      Certificate. The Participant also agrees that the Phantom Shares will be governed by the terms of this
      Agreement and the Award Certificate.
    </p>

    <div class="accept-footer">
      <div class="accept-participant-wrapper">
        <div>{{ $dataDirectory.userData.firstName }} {{ $dataDirectory.userData.lastName }}</div>
        <div class="accept-participant">
          Participant Name
        </div>
      </div>
      <div class="accept-date-wrapper">
        <div>{{ formatDate(new Date(), '', 'DIRECT') }}</div>
        <div class="accept-date">
          Date
        </div>
      </div>
      <div class="accept-button-wrapper">
        <button @click="onAccept">
          Acknowledged & Accepted
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PDFViewer from "@/components/elements/PDFViewer.vue";
import VLdate from '@/composables/VLdate';
export default {
  name: 'AcceptCertificate',
  components: {
    PDFViewer,
  },
  props: {
    certificate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      viewDimensions: {
        width: null,
        height: null,
      },
    }
  },
  computed: {
    certificateUrl() {
      return this.$apiManager.route(`grant-certificate/${this.certificate.granted_shares_id}`);
    },
    daysRemaining() {
      // Must accept within 60 days. Returns 60 - number of full days since publishing
      return 60 - Math.floor((new Date() - new Date(this.certificate.published_at.split(' ')[0])) / (1000*60*60*24));
    },
  },
  created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },

  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    formatDate(d, format, preset) {
      return VLdate.formatDate(d, format, preset);
    },

    onDownload() {
      this.certificateDownloaded = true;

      window.open(this.certificateUrl, '_blank').focus();
    },

    onAccept() {
      let payload = {"granted_shares_id": this.certificate.granted_shares_id}

      this.$apiManager.post(`certificate/accept`, payload)
          .then((result) => {
            if(result.data.success) this.$emit('getPendingCertificates');
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {})
    },
    onResize() {
      this.viewDimensions.width = window.innerWidth;
      this.viewDimensions.height = window.innerHeight;
    },
  }
}
</script>

<style lang="scss" scoped>
@use "../../scss/_variables.scss";

.accept-container {
  display: flex;
  flex-direction: column;

  p {
    font-weight: bold;
    margin-bottom: 1rem;
  }
}

.accept-pdf-wrapper {
  margin-bottom: 1rem;
}

.accept-participant-wrapper {
  flex-grow: 5;
}

.accept-date-wrapper {
  flex-grow: 2
}

.accept-participant, .accept-date {
  border-top: solid 1px variables.$charcoal;

  font-weight: bold;
}

.accept-footer {
  display: flex;

  >div {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:nth-child(2) {
      padding: 0 3rem;
    }
  }
}

@media screen and (max-width: 600px) {
  .accept-footer {
    flex-direction: column;
    gap: 16px;

    >div {
      &:nth-child(2) {
        padding: 0 0;
      }
    }
  }
}
</style>